import React, { useRef, useEffect, useState } from "react";
import "./UserIdCard.css";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";

import { auth, db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function UserIdCard() {
  const cardRef = useRef();
  const navigate = useNavigate();

  const [userData, setUserData] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [photoBroken, setPhotoBroken] = useState(false);

  useEffect(() => {
    try {
      const data = JSON.parse(localStorage.getItem("user"));
      if (data) {
        setUserData(data);
        setPhotoBroken(!data.photoURL);
      }
    } catch (e) {
      console.error("Parse error:", e);
    }
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      try {
        await updateDoc(doc(db, "users", user.uid), { status: "completed" });
      } catch (err) {
        console.log("Status update error:", err);
      }
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);

  const downloadCard = async () => {
    try {
      if (!cardRef.current) return;
      const canvas = await html2canvas(cardRef.current);
      const link = document.createElement("a");
      link.download = "User_ID_Card.png";
      link.href = canvas.toDataURL();
      link.click();
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  if (!userData) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h2>Loading User Card...</h2>
      </div>
    );
  }

  const initial = (userData?.name || userData?.email || "U").trim().charAt(0).toUpperCase();

  return (
    <div className="user-id-container">
      <div className="user-id-card" ref={cardRef}>
        <h2 style={{ marginBottom: "5px" }}>Connect</h2>
        <p>Digital User Card</p>

        <div className="profile">
          {!photoBroken && userData?.photoURL ? (
            <img
              src={userData.photoURL}
              alt="profile"
              className="profile-img"
              onClick={() => setShowPreview(true)}
              onError={() => setPhotoBroken(true)}
            />
          ) : (
            <div
              style={{
                width: 80, height: 80, borderRadius: "50%",
                background: "linear-gradient(135deg, #00c9b1, #0077cc)",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "#fff", fontWeight: 800, fontSize: 32,
                border: "3px solid #00c9b1", margin: "0 auto",
                cursor: "pointer"
              }}
              onClick={() => setShowPreview(false)}
            >
              {initial}
            </div>
          )}
        </div>

        <p><strong>ID:</strong> {userData?.id || "USR000"}</p>
        <p><strong>Name:</strong> {userData?.name || "User"}</p>
        <p><strong>Email:</strong> {userData?.email || "N/A"}</p>
        <p><strong>Phone:</strong> {userData?.phone || "N/A"}</p>

        <div style={{ margin: "15px 0" }}>
          <QRCode value={userData?.id || userData?.uid || "USER"} size={80} />
        </div>

        <div className="badge">✔ Verified User</div>
      </div>

      <button className="download-btn" onClick={downloadCard}>
        ⬇ Download ID
      </button>

      <p style={{ marginTop: "10px" }}>Redirecting to dashboard...</p>

      {showPreview && userData?.photoURL && !photoBroken && (
        <div className="image-modal" onClick={() => setShowPreview(false)}>
          <img
            src={userData.photoURL}
            alt="preview"
            className="modal-img"
            onError={() => { setPhotoBroken(true); setShowPreview(false); }}
          />
        </div>
      )}
    </div>
  );
}
